import { AggregationType } from '@carto/api-client'
import { MapDatasetEnriched } from 'features/builder/types'

export type OperationListEntry = AggregationType | 'divider'

export const DefaultAggregationTypes: AggregationType[] = ['avg', 'count', 'max', 'min', 'sum']

export const FormulaWidgetAggregationTypes: OperationListEntry[] = [...DefaultAggregationTypes, 'divider', 'custom']

export function isValidOperation({
  operation,
  operationColumn,
  source,
  supportedTypes
}: {
  operation?: AggregationType
  operationColumn?: string
  source?: MapDatasetEnriched
  supportedTypes?: string[]
}) {
  if (!operation) return false
  if (operation === 'count') return true

  if (!operationColumn) return false
  if (source?.fields) {
    const field = source?.fields.find((f) => f.id === operationColumn)
    if (!field) return false

    if (supportedTypes && !supportedTypes.includes(field.type)) return false
  }

  return true
}

export function sourceHasType(source: MapDatasetEnriched, requestedType: string | string[]) {
  return source.fields?.some((field) =>
    Array.isArray(requestedType) ? requestedType.includes(field.type) : requestedType === field.type
  )
}
